import { Navigate, Route, Routes } from 'react-router'
import { Empty } from '@/components/layout/Page'
import { homeFor } from '@/components/layout/nav'
import { useSession } from '@/hooks/useSession'
import MyPage from './me/MyPage'
import NewSshKey from './me/NewSshKey'
import SshKeys from './me/SshKeys'
import CreateVm from './vm/CreateVm'
import { SCREEN_ROUTES } from './routeList'
import type { World } from './model'

export function Screens({ world, query, loading }: { world: World; query: string; loading: boolean }) {
  const props = { world, query, loading }
  // 화면도 메뉴와 같은 표를 본다(F-38): 관리자에게 열리지 않는 경로는 없는 화면이다.
  const { role } = useSession()
  const top = role === 'superadmin'
  const screens = SCREEN_ROUTES.filter((s) => top || !s.top)
  return (
    <Routes>
      {/* 내 정보(F-37)는 레일의 화면이 아니라 계정 메뉴가 여는 자리라 화면 목록 밖에 둔다. */}
      <Route path="/me" element={<MyPage />} />
      <Route path="/me/keys" element={<SshKeys />} />
      <Route path="/me/keys/new" element={<NewSshKey />} />
      {/* VM 생성 페이지는 VM 목록의 버튼이 여는 자리라 레일의 화면 목록 밖에 둔다 — 사이드바의 활성은 `VM` 에 남는다. */}
      <Route path="/vms/new" element={<CreateVm />} />
      {/* 로그인 화면은 어느 경로에서나 서므로 로그인 직후 주소가 /login 으로 남을 수 있다 — 첫 화면으로 보낸다. */}
      <Route path="/login" element={<Navigate to={top ? '/' : homeFor(role, 0)} replace />} />
      {screens.map((screen) => (
        <Route key={screen.path} path={screen.path} element={screen.render(props)} />
      ))}
      {/* 관리자에게는 대시보드(/)가 없다 — 열리지 않는 경로는 막다른 화면이 아니라 첫 화면으로 간다. */}
      <Route path="*" element={top ? <Empty>없는 화면</Empty> : <Navigate to={homeFor(role, 0)} replace />} />
    </Routes>
  )
}
